const keys = {
  // Local Storage key
  todo_list: "todo_list",

  // Constructor key
  id: "_id",
  categoryPath: '_categoryPath',
  sections: "_sections",
  tasks: "_tasks",
  subtasks: "_subtasks",

  // Category title
  projectTitle: "projectTitle",
  sectionTitle: "sectionTitle",
  taskTitle: "taskTitle",
  subtaskTitle: "subtaskTitle",

  // Root key
  inbox: "Inbox",
  myProject: "My Project",

  // Task Dialog save action
  edit: "edit",
  new: "new"
};

export default keys;
